import angular from 'angular';
import _ from 'lodash';
export class PatientCheckInModalService {
    constructor(pn, patientService, trackingFactory, $window, $timeout, notificationFactory, $log, notifications, $rootScope) {
        this.pn = pn;
        this.patientService = patientService;
        this.trackingFactory = trackingFactory;
        this.$window = $window;
        this.$timeout = $timeout;
        this.notificationFactory = notificationFactory;
        this.$log = $log;
        this.notifications = notifications;
        this.$rootScope = $rootScope;
        this.checkInErrorCount = 0;
    }
    async checkIn({ room, patient, fromRoomId = null, skipSegmentTrack = false, }) {
        this.notifications.closeAll();
        if (this.checkInPromise)
            return this.checkInPromise;
        return (this.checkInPromise = this.patientService
            .checkInAsPatient({ room: room, patient: patient, fromRoomId })
            .then(() => {
            if (!skipSegmentTrack) {
                this.trackingFactory.global.track('Checkin Completed', {
                    user_type: 'patient',
                    checkin_type: 'classic',
                    room_id: room.id,
                    microphone: this.pn.globalState.hasMic,
                    camera: this.pn.globalState.hasCamera || false,
                    media_access_granted: this.pn.globalState.hasCameraAccess ||
                        this.pn.globalState.hasMicrophoneAccess,
                    proceed_without_media: !this.pn.globalState.hasCameraAccess &&
                        !this.pn.globalState.hasMicrophoneAccess,
                    plan_type: undefined,
                });
            }
        })
            .catch(async (err) => {
            if (err.code === 'INCORRECT_PASSCODE') {
                this.notificationFactory.showCommon('error', err.message);
                return Promise.reject();
            }
            const level = err ? 'info' : 'error';
            this.$log[level]('PatientController', {
                action: 'PatientController',
                error: err,
                room: _.pick(room, ['slug', 'name']),
            });
            if (this.checkInErrorCount >= 2) {
                await this.pn.stop();
                this.notificationFactory.showCommon('error', 'catch-all', 'realtime-error');
                return Promise.reject();
            }
            return this.$timeout(() => {
                this.checkInPromise = null;
                return this.checkIn({ room, patient });
            }, this.checkInErrorCount++ * 2500);
        })
            .finally(() => {
            this.checkInPromise = null;
        }));
    }
}
export default angular
    .module('doxy.patient.modal.common.services.patientCheckInModalService', [])
    .service('patientCheckInModalService', PatientCheckInModalService).name;
